export default "__VITE_ASSET__CR3P5YLI__"